import { makeStyles, useTheme } from '@rneui/themed'
import React from 'react'
import {
  ColorValue,
  ImageChangeEvent,
  StyleProp,
  TextStyle,
  View,
  ViewStyle,
} from 'react-native'
import { TextInput } from 'react-native-gesture-handler'

interface TextInputBoxProps {
  placeholder?: string
  value?: string
  onChangeText(text: string): void
  onImageChange?: (event: ImageChangeEvent) => void
  maxLength?: number
  containerStyle?: StyleProp<ViewStyle>
  style?: StyleProp<TextStyle>
  placeholderTextColor?: ColorValue | undefined
}

export function TextInputBox({
  placeholder,
  onChangeText,
  onImageChange,
  value,
  maxLength,
  containerStyle,
  style,
  placeholderTextColor,
}: TextInputBoxProps) {
  const styles = useStyles()
  const { theme } = useTheme()
  return (
    <View style={[styles.textInputContainer, containerStyle]}>
      <TextInput
        spellCheck={false}
        onChangeText={onChangeText}
        onImageChange={onImageChange}
        multiline
        placeholder={placeholder}
        placeholderTextColor={placeholderTextColor ?? theme.colors.grey2}
        value={value}
        style={[styles.textInput, style]}
        selectionColor={theme.colors?.primary}
        maxLength={maxLength}
      ></TextInput>
    </View>
  )
}

const useStyles = makeStyles((theme, height: number) => ({
  textInputContainer: {
    flex: 1,
    paddingBottom: 10,
  },
  textInput: {
    flex: 1,
    marginTop: 10,
    color: theme.colors?.grey0,
    borderRadius: 10,
    backgroundColor: theme.colors?.grey5,
    textAlignVertical: 'top',
    padding: 10,
  },
}))
